import { render, staticRenderFns } from "./WebLayout.vue?vue&type=template&id=40665fc6&"
import script from "./WebLayout.vue?vue&type=script&lang=js&"
export * from "./WebLayout.vue?vue&type=script&lang=js&"
import style0 from "./WebLayout.vue?vue&type=style&index=0&id=40665fc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
